import {useEffect, useState} from "react";
import trainerApi from "../../api/trainer/trainer";
import trainingCategoryApi from "../../api/trainingCategory/trainingCategory";
import {ui} from "../../helpers/ui";

const InitTrainersLogic = () => {
  const [trainers, setTrainers] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const [editingId, setEditingId] = useState<number | null>(null);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    username: "",
    password: "",
    disabled: false,
  });
  // Cene se cuvaju kao STRING (da polje moze da bude prazno dok se kuca);
  // u broj se pretvara tek na cuvanje, uz obaveznu validaciju.
  const [categoryPrices, setCategoryPrices] = useState<Record<number, string>>({});

  const loadTrainers = () => {
    trainerApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setTrainers(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const loadCategories = () => {
    trainingCategoryApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setCategories(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  useEffect(() => {
    loadTrainers();
    loadCategories();
  }, []);

  const onChange = (event: any) => {
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    setForm({...form, [event.target.name]: value});
  };

  const onSave = () => {
    if (!form.firstName || !form.lastName || !form.username) {
      ui.alert("Sva polja su obavezna");
      return;
    }
    // Cena je OBAVEZNA za svaku kategoriju (broj >= 0; 0 ako trener ne radi tu
    // kategoriju). Prazno/neispravno blokira cuvanje - da se ne upise slucajno 0.
    const numericCategoryPrices: Record<number, number> = {};
    for (const cat of categories) {
      const raw = categoryPrices[cat.id];
      const num = Number(raw);
      if (raw === undefined || raw === "" || isNaN(num) || num < 0) {
        ui.alert(`Cena za kategoriju "${cat.name}" je obavezna (unesite broj, 0 ako nema).`);
        return;
      }
      numericCategoryPrices[cat.id] = num;
    }
    if (editingId) {
      const data: any = {
        firstName: form.firstName,
        lastName: form.lastName,
        disabled: form.disabled,
        categoryPrices: numericCategoryPrices,
      };
      if (form.username) data.username = form.username;
      if (form.password) data.password = form.password;
      trainerApi
        .update(editingId, data)
        .then(() => {
          resetForm();
          loadTrainers();
        })
        .catch((e) => ui.alert(e.response?.data?.error?.message || "Greška"));
    } else {
      if (!form.password) {
        ui.alert("Lozinka je obavezna");
        return;
      }
      trainerApi
        .create({
          firstName: form.firstName,
          lastName: form.lastName,
          username: form.username,
          password: form.password,
          disabled: form.disabled,
          categoryPrices: numericCategoryPrices,
        })
        .then(() => {
          resetForm();
          loadTrainers();
        })
        .catch((e) => ui.alert(e.response?.data?.error?.message || "Greška"));
    }
  };

  const onEdit = (trainer: any) => {
    setEditingId(trainer.id);
    setForm({
      firstName: trainer.firstName,
      lastName: trainer.lastName,
      username: trainer.username,
      password: "",
      disabled: trainer.disabled ?? false,
    });
    const cp: Record<number, string> = {};
    for (const c of trainer.categoryPrices || []) {
      cp[c.trainingCategoryId] = String(c.price ?? "");
    }
    setCategoryPrices(cp);
  };

  const onCategoryPriceChange = (categoryId: number, value: string) => {
    // Cuva sirov string (dozvoljava prazno polje); u broj tek na cuvanje.
    setCategoryPrices({...categoryPrices, [categoryId]: value});
  };

  const onDelete = async (id: number) => {
    const confirmed = await ui.confirm("Sigurno želite da obrišete trenera?");
    if (!confirmed) return;
    trainerApi
      .remove(id)
      .then(() => loadTrainers())
      .catch((e) => ui.alert(e.response?.data?.error?.message || "Greška"));
  };

  const resetForm = () => {
    setEditingId(null);
    setForm({
      firstName: "",
      lastName: "",
      username: "",
      password: "",
      disabled: false,
    });
    setCategoryPrices({});
  };

  return {
    trainers,
    categories,
    categoryPrices,
    form,
    editingId,
    onChange,
    onCategoryPriceChange,
    onSave,
    onEdit,
    onDelete,
    resetForm,
  };
};

export default InitTrainersLogic;
